import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { CommonService } from '../../service/common.service';

declare var $;

@Component({
  selector: 'app-b-datefromto1',
  templateUrl: './b-datefromto1.component.html',
  styleUrls: ['./b-datefromto1.component.css']
})
export class BDateFromto1Component implements OnInit {
  @Input() base: any;

  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;
  @Output() t_result_listChange = new EventEmitter();

  @Input() isEnable: boolean;

  inputText;
  required_flg: boolean;

  MODE: any = Mode;
  Q_TYPE:any = QuestionType;

  
  maxyear:number=2000;
  minyear:number=1901;
  maxmonth:number=12;

  fromyyyy:string="";
  frommm:string="";
  toyyyy:string="";
  tomm:string="";

  retval:string="";
  fromvalue:string = "";
  tovalue:string = "";
  fromdate:Date;
  todate:Date;
  error0:boolean=false;
  error1:boolean=false;
  error2:boolean=false;

  constructor(
    private commonService: CommonService
  ) { }

//null/null～null/null　→　「」
//2000/1～null/null　→　「2000/1～」
//null/null～2000/1　→　「～2000/1」
//という文字列で登録する

ngOnInit() {
  this.question.t_result_list.error_msg  ="";

  var now   = new Date();       
  this.maxyear=now.getFullYear(); //年
  this.maxmonth=now.getMonth()+1;//月
  //初めて
  if (this.question.t_result_list.t_result_answer_str==null || this.question.t_result_list.t_result_answer_str==''){
    this.fromyyyy="";
    this.frommm="";
    this.toyyyy="";
    this.tomm="";
  }else{
    var temp1=[];
    var temp2=[];

    //～でsplit
    temp1 = this.question.t_result_list.t_result_answer_str.split('～');

    if (temp1[0]==''){
      this.fromyyyy="";
      this.frommm="";
    } else{
      // /でsplit
      temp2 = temp1[0].split('/');

      this.fromyyyy=temp2[0];
      this.frommm=temp2[1];
    } 
    if (temp1[1]=='' ){
      this.toyyyy=null;
      this.tomm=null;
    } else{
      // /でsplit
      temp2 = temp1[1].split('/');

      this.toyyyy=temp2[0];
      this.tomm=temp2[1];
    }
  };

    this.required_flg = this.commonService.exchange01toTF(this.question.m_question_required_flg);
  }

  onBlurMethod(): void {
    this.question.t_result_list.error_msg  ="";
    this.fromdate=null;
    this.todate=null;

    //4文字以上はカット
    if(String(this.fromyyyy).length>4&&this.fromyyyy!=null){
      this.fromyyyy = String(this.fromyyyy).slice(0, 4)
    }
    if(String(this.frommm).length>2&&this.frommm!=null){
      this.frommm = String(this.frommm).slice(0, 2)
    }
    if(String(this.toyyyy).length>4&&this.toyyyy!=null){
      this.toyyyy = String(this.toyyyy).slice(0, 4)
    }
    if(String(this.tomm).length>2&&this.tomm!=null){
      this.tomm = String(this.tomm).slice(0, 2)
    }

    var now = new Date();
    var from = new Date(parseInt(this.fromyyyy), parseInt(this.frommm)-1, 2, 0, 0, 0);
    var to = new Date(parseInt(this.toyyyy), parseInt(this.tomm)-1, 2, 0, 0, 0);

    if(this.fromyyyy==null&&this.frommm==null){
      this.error0 = true;
    }
    if((this.fromyyyy==""||this.fromyyyy==null) && (this.frommm==""||this.frommm==null) && (this.toyyyy==""||this.toyyyy==null) && (this.tomm==""||this.tomm==null)) {
      this.fromvalue = "";
      this.tovalue = "";
      this.question.t_result_list.error_msg  ="";
      return;
    }
    if(!this.checkNumberFormat(this.fromyyyy) || !this.checkNumberFormat(this.frommm)) {
      this.fromvalue = "";
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[From] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";

    }
    if(!this.checkNumberFormat(this.toyyyy) || !this.checkNumberFormat(this.tomm)) {
      this.tovalue = "";
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[To] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";

    }
    if (this.question.t_result_list.error_msg !=""){
      return;
    }


    if (this.fromyyyy=="" && this.frommm=="")
    {

    }else if (parseInt(this.fromyyyy,10)>=this.minyear && parseInt(this.fromyyyy,10)<=this.maxyear &&
        parseInt(this.frommm,10)>=1 && parseInt(this.frommm,10)<=12)
    {
      this.fromdate = new Date(parseInt(this.fromyyyy,10),parseInt(this.frommm,10)-1,1);
      this.fromdate.constructor;
      if(this.fromdate.toString() === "Invalid Date"){
        this.fromvalue = "";
        this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[From] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";
      }else{
        this.fromvalue = this.fromyyyy+'/'+this.frommm;
      }
    }else{
      this.fromvalue = "";
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[From] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";
    }
    // 未来日付が入力された場合エラー
    if(this.fromvalue!=""&&from>now){
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[From] value.  year -> ~"+this.maxyear+"/ month -> ~"+this.maxmonth+".";
    }

    if ((this.toyyyy==""||this.toyyyy==null) && (this.tomm==""||this.tomm==null))
    {

    }else if(parseInt(this.toyyyy,10)>=this.minyear && parseInt(this.toyyyy,10)<=this.maxyear &&
      parseInt(this.tomm,10)>=1 && parseInt(this.tomm,10)<=12)
    {
      this.todate = new Date(parseInt(this.toyyyy,10),parseInt(this.tomm,10)-1,1);
      this.todate.constructor;
      if(this.todate.toString() === "Invalid Date"){
        this.tovalue = "";
        this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[To] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";
      }else{
        this.tovalue = this.toyyyy+'/'+this.tomm;
      }
    }else{
      this.tovalue = "";
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[To] value.  year -> "+this.minyear+"~"+this.maxyear+"/ month -> 1~12. ";
    }
    // 未来日付が入力された場合エラー
    if(this.tovalue!=""&&to>now){
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "[To] value.  year -> ~"+this.maxyear+"/ month -> ~"+this.maxmonth+".";
    }

    if(this.fromdate!=null && this.todate !=null && this.fromdate>this.todate){
      this.question.t_result_list.error_msg = this.question.t_result_list.error_msg  + "Please enter the correct period.";
    }

    if(this.question.t_result_list.error_msg == ""){
      if (this.fromvalue=="" && this.tovalue =="")
      {
        this.question.t_result_list.t_result_answer_str = "";
      }else{
        this.question.t_result_list.t_result_answer_str = this.fromvalue + "～"+ this.tovalue;
        this.error0 = false;
      }
    }

  }
//数字かどうかの入力チェック
checkNumberFormat(values:any){
  if (values==null || values==''){
    return true;
  }else{
    //値が数値だけか
    var regex = new RegExp(/^[0-9]+$/);
    return regex.test(values);
  }
}

}



// WEBPACK FOOTER //
// ./src/app/parts/b-datefromto1/b-datefromto1.component.ts